import { logoUrl } from "@/lib/site-data";

export const AboutPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-20 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section className="grid items-center gap-10 lg:grid-cols-[1.2fr_1fr]">

        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
            About The AI Matters
          </p>

          <h1 className="mt-4 text-4xl font-bold md:text-5xl">
            Building the Future of AI-Driven Hiring Infrastructure
          </h1>

          <p className="mt-6 text-[#D9E1E8]/80 text-lg">
            The AI Matters is an AI-powered hiring infrastructure company
            designed to help organizations modernize the way they discover,
            evaluate, and hire talent. We combine artificial intelligence,
            recruiter networks, and structured hiring workflows to create a
            scalable hiring operating system.
          </p>

          <p className="mt-4 text-[#D9E1E8]/80">
            Our platform enables companies to move beyond traditional hiring
            processes by introducing intelligent candidate evaluation,
            transparent recruiter collaboration, and real-time hiring insights.
          </p>
        </div>

        <div className="glass-panel rounded-3xl p-8">
          <img
            src={logoUrl}
            alt="The AI Matters logo"
            className="mx-auto w-full max-w-[280px] rounded-full glow-ring"
          />
        </div>

      </section>


      {/* MISSION */}
      <section className="grid gap-8 md:grid-cols-2">

        <div className="glass-panel rounded-2xl p-8">
          <h2 className="text-2xl font-bold mb-4">
            Our Mission
          </h2>

          <p className="text-[#D9E1E8]/80">
            Our mission is to transform hiring into a scalable operating
            system where organizations can consistently discover high-quality
            talent while maintaining speed, transparency, and governance.
          </p>

          <p className="mt-4 text-[#D9E1E8]/80">
            By integrating AI intelligence with structured workflows and
            recruiter ecosystems, we help companies reduce hiring friction
            and make better talent decisions.
          </p>
        </div>


        <div className="glass-panel rounded-2xl p-8">
          <h2 className="text-2xl font-bold mb-4">
            Our Vision
          </h2>

          <p className="text-[#D9E1E8]/80">
            We envision a world where hiring is no longer fragmented,
            slow, or inconsistent. Instead, organizations operate with
            a unified hiring infrastructure powered by intelligent
            technology and trusted talent networks.
          </p>

          <p className="mt-4 text-[#D9E1E8]/80">
            The AI Matters aims to become the operating layer that
            connects companies, recruiters, and talent through
            data-driven hiring systems.
          </p>
        </div>

      </section>


      {/* PLATFORM EXPLANATION */}
      <section>

        <h2 className="text-3xl font-bold mb-6">
          The Technology Behind The AI Matters
        </h2>

        <p className="max-w-4xl text-[#D9E1E8]/80">
          Our proprietary platform, JobScore Matters, acts as the core
          operating layer for modern hiring programs. It combines AI-based
          candidate scoring, recruiter collaboration tools, structured
          hiring workflows, and real-time hiring analytics into one
          integrated environment.
        </p>

        <p className="mt-4 max-w-4xl text-[#D9E1E8]/80">
          This infrastructure enables organizations to scale hiring
          operations efficiently while maintaining quality standards,
          governance, and measurable performance outcomes.
        </p>

      </section>


      {/* WHY WE EXIST */}
      <section className="glass-panel rounded-2xl p-10">

        <h2 className="text-3xl font-bold mb-4">
          Why We Built The AI Matters
        </h2>

        <p className="max-w-3xl mx-auto text-center text-[#D9E1E8]/80">
          Hiring remains one of the most critical yet inefficient functions
          within organizations. Fragmented tools, inconsistent processes,
          and lack of visibility often lead to slow hiring cycles and poor
          candidate experiences.
        </p>

        <p className="mt-4 max-w-3xl mx-auto text-center text-[#D9E1E8]/80">
          The AI Matters was created to solve this challenge by introducing
          a unified hiring infrastructure that brings together AI
          intelligence, recruiter networks, and structured decision systems.
        </p>

      </section>

    </div>
  );
};